import { getApiBaseUrl } from '../../../utils/apiConfig';

const BASE = () => `${getApiBaseUrl()}/api/process-config/email-notifications`;

export async function fetchConfig(token) {
  const res = await fetch(`${BASE()}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Erro ao buscar configuração');
  const j = await res.json();
  if (!j.success) throw new Error(j.message || 'Erro');
  return j.data;
}

export async function saveConfig(token, payload) {
  const res = await fetch(`${BASE()}/save`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const j = await res.json();
  if (!j.success) throw new Error(j.message || 'Erro ao salvar');
  return j;
}

export async function testConfig(token, payload) {
  const res = await fetch(`${BASE()}/test`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const j = await res.json();
  return j;
}

export async function fetchNotificationTypes(token) {
  const res = await fetch(`${BASE()}/notification-types`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Erro ao buscar');
  const j = await res.json();
  if (!j.success) throw new Error(j.message || 'Erro');
  return j.data;
}

export async function saveNotificationTypes(token, payload) {
  const res = await fetch(`${BASE()}/notification-types`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const j = await res.json();
  if (!j.success) throw new Error(j.message || 'Erro');
  return j;
}

export async function sendSeraAtendidaAmanha(token, orderIds) {
  const res = await fetch(`${BASE()}/send-sera-atendida-amanha`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderIds })
  });
  const j = await res.json();
  return j;
}

export async function sendSeraAtendidaHoje(token, orderIds) {
  const res = await fetch(`${BASE()}/send-sera-atendida-hoje`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderIds })
  });
  const j = await res.json();
  return j;
}

export async function sendOSConcluida(token, codFechamentos) {
  const res = await fetch(`${BASE()}/send-os-concluida`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ codFechamentos })
  });
  const j = await res.json();
  return j;
}

export async function oauthInit(token) {
  const res = await fetch(`${BASE()}/oauth/google/init`, { headers: { Authorization: `Bearer ${token}` } });
  const j = await res.json();
  return j;
}

export async function sendTestEmail(token, payload) {
  const res = await fetch(`${BASE()}/send-test`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const j = await res.json();
  return j;
}
